import {msg} from '@lit/localize';
import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {property} from 'lit/decorators/property.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import {updatePersonalisation} from '../../slices/configurationSlice';
import store from '../../store';

@customElement('personalise-field')
class PersonaliseField extends LitElement {

	@property({type: String})
	name = '';

	@property({type: String})
	label = '';

	@property({type: String})
	value = '';

	@property({type: Boolean})
	isTextArea = false;

	@property({type: Boolean})
	print = false;

	static styles = css`

		.formRow {
			display: flex;
			flex-direction: column;
			gap: 0.5cqw;
		}

		.value {
			font: var(--font-specsheet-print-small-light);
			font-size: max(2cqw, 12px);
			padding: 1cqw 0;
			border: none;
			color: black;
			border-bottom: 1px solid var(--color-widget-border);
		}


		.print .note {
			border: none;
		}

		.value, .note, .grow-wrap::after {
			width: 100%;
		}

		.note, .grow-wrap::after {
			padding: 8px;
			border: 1px solid var(--color-widget-border);
			margin-top: 2px;
			height: 100px;
		}

		.print .note {
			padding: 8px 0;
		}

		.value::placeholder, .note::placeholder {
			font: var(--font-specsheet-print-small-light);
			color: var(--color-widget-border);
			font-size: 2cqw;
			opacity: 0;
		}

		.print .value, .print .note {
			font-size: 2cqw;
		}

		.label {
			display: block;
			color: black;
			font: var(--font-specsheet-print-small-bold);
			font-weight: bold;
			font-size: max(2cqw, 12px);
			padding-right: 1cqw;
			white-space: nowrap;
			flex: 1;
		}

		.print .label {
			font-size: 2cqw;
		}

		// https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/
		// waiting for field-sizing: https://caniuse.com/?search=field-sizing

		.grow-wrap {
			display: grid;
		}

		.grow-wrap::after {
			content: attr(data-replicated-value) " ";
			white-space: pre-wrap;
			visibility: hidden;
		}

		.grow-wrap > textarea {
			resize: none;
			overflow: hidden;
		}

		.grow-wrap > textarea,
		.grow-wrap::after {
			grid-area: 1 / 1 / 2 / 2;
		}


	`;

	onChange(ev) {
		store.dispatch(updatePersonalisation({name: ev.target.name, value: ev.target.value}));
	}

	render() {
		if (this.print && !this.value) {
			return null;
		}
		return html`
			<div class="formRow ${classMap({print: this.print})}">
				<label class="label" for="${this.name}">${this.label}</label>
				${when(this.isTextArea, () => (
					this.print ?
						(html`<p class="note">${unsafeHTML(this.value.replace(/\n/g, '<br />'))}</p>`) :
						(html`
							<div class="grow-wrap" data-replicated-value="${this.value}">
								<textarea class="note" maxlength="600" placeholder="${this.label}" name="${this.name}" id="${this.name}"
										  @input=${ev => this.onChange(ev)}>${this.value}</textarea>
							</div>`)
				), () => (
					this.print ?
						(html`<span class="value">${this.value}</span>`) :
						(html`<input class="value" value=${this.value} placeholder="${this.label}" type="text"
									 name="${this.name}"
									 id="${this.name}" @input=${ev => this.onChange(ev)}/>
						`)
				))}

			</div>
		`;
	}
}
